import {Redirect, useHistory} from '@aboutyou/router';
import React, {FC} from 'react';
import {DEEP_LINKS} from './useDeepLinkOpener';

export const DeepLinkLoaderPage: FC<{
  openCouponWallet?: boolean;
  openCoinsWallet?: boolean;
  openNewsletter?: boolean;
  openCoinsHistory?: boolean;
}> = ({
  openCouponWallet,
  openCoinsHistory,
  openCoinsWallet,
  openNewsletter,
}) => {
  const {location} = useHistory();
  const searchParams = new URLSearchParams(location.search);

  if (openCouponWallet) {
    searchParams.set(DEEP_LINKS.cw, 'true');
    return <Redirect to={`/?${searchParams.toString()}`} />;
  }

  if (openCoinsWallet) {
    searchParams.set(DEEP_LINKS.coins, 'true');
    return <Redirect to={`/?${searchParams.toString()}`} />;
  }

  if (openNewsletter) {
    searchParams.set(DEEP_LINKS.newsletterSubscription, 'true');
    return <Redirect to={`/?${searchParams.toString()}`} />;
  }

  if (openCoinsHistory) {
    searchParams.set(DEEP_LINKS.coinsHistory, 'true');
    return <Redirect to={`/?${searchParams.toString()}`} />;
  }

  return null;
};
